// extracted by mini-css-extract-plugin
export default {"error":"Image_error__eVwAK"};